export default "__VITE_ASSET__BsOF1KWk__"